import { render, staticRenderFns } from "./orderSubmissionModal.vue?vue&type=template&id=af967c9e&scoped=true"
import script from "./orderSubmissionModal.vue?vue&type=script&lang=js"
export * from "./orderSubmissionModal.vue?vue&type=script&lang=js"
import style0 from "./orderSubmissionModal.vue?vue&type=style&index=0&id=af967c9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af967c9e",
  null
  
)

export default component.exports